import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  height: 65vh;
`;

const P = styled.p`
  margin: 0;
  color: ${props => props.title ? '#C9B79F' : null};
  font-size: 12px;
  font-weight: ${props => props.bold? 'bold' : null};
  margin-top: ${props => props.title? '10px' : null};
  margin-bottom: ${props => props.spaceBottom? '10px' : null};
  max-width: 180px;
  text-align: center;
`;

const Button = styled.button`
  background-color: #C9B79F;
  border: 1px solid #C9B79F;
  border-radius: 3px;
  padding: 5px 10px;
  margin-bottom: 10px;
  text-transform: uppercase;
  font-weight: bold;
  color: white;
`;

const InfoContainer = styled.div`
  width: 220px;
  max-height: 320px;
  overflow-x: hidden;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (max-width: 768px) {
    width: 180px;
    max-height: 200px;
    padding-right: 10px;
  }
`;

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20% 0;
  @media (max-width: 768px) {
    margin: 45% 0;
  }
`;

export {
  Container,
  P,
  Button,
  InfoContainer,
  LoadingContainer,
};